import React, { useState, useEffect } from 'react';
import Joyride, { Step } from 'react-joyride';

interface TutorialProps {
  initialDelay?: number;
  force?: boolean;
  onClose?: () => void;  // Add this prop
}

export default function Tutorial({ initialDelay = 5000, force = false, onClose }: TutorialProps) {
  const [run, setRun] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const hasSeenTutorial = localStorage.getItem('tutorialComplete');
    
    if (!hasSeenTutorial || force) {
      const timer = setTimeout(() => {
        setRun(true);
      }, initialDelay);
      
      return () => clearTimeout(timer);
    }
  }, [initialDelay, force]);

  const steps: Step[] = [
    {
      target: '.availability-button',
      content: 'Bem vindo ao QueroJogar! Neste botão você diz em que dias e horários na semana você pode jogar, assim outros jogadores podem saber e te contatar.',
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '.propose-game-button',
      content: 'Aqui você cadastra um jogo e jogadores podem se increver para jogar com você.',
      placement: 'bottom'
    },
    {
      target: '.segment-control',
      content: 'Use essas abas para navegar entre "Disponibilidades" (jogadores querendo jogar) e "Jogos" (jogos esperando jogadores). Clique em "Jogos" para ver os jogos disponíveis!',
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '.game-card',
      content: 'Este é um card de jogo. Aqui você encontra informações sobre jogos propostos por outros jogadores ou organizadores.',
      placement: 'bottom',
    },
    {
      target: '.availability-card',
      content: 'Este é um card de disponibilidade. Jogadores mostram aqui quando podem jogar.',
      placement: 'bottom',
    },
    {
      target: '.filter-button',
      content: 'Use o filtro para facilitar a busca por jogadores e jogos compatíveis com você!',
      placement: 'bottom'
    },
    {
      target: 'button:has(.lucide-bell)',
      content: 'Este é o sino de notificações! Aqui você recebe avisos quando outros jogadores compatíveis estão disponíveis ou quando alguém se interessa pelos seus jogos.',
      placement: 'bottom'
    },
    {
      target: 'button:has(img[alt="Avatar"]), button:has(.w-8.h-8.rounded-full)',
      content: 'Clique no seu perfil para editar suas informações, ver seu histórico de jogos e gerenciar suas configurações.',
      placement: 'bottom'
    }
  ];

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose
      disableScrolling={false}
      spotlightClicks
      styles={{
        options: {
          primaryColor: '#2563eb',
          textColor: '#111827',
          zIndex: 10000,
          width: isMobile ? '80vw' : 500,
        }
      }}
      locale={{
        back: 'Anterior',
        close: 'Fechar',
        last: 'Finalizar',
        next: 'Próximo',
        skip: 'Pular'
      }}
      callback={({ status }) => {
        console.log('Tutorial status:', status);
        if (['finished', 'skipped'].includes(status)) {
          setRun(false);
          localStorage.setItem('tutorialComplete', 'true');
          onClose?.();  // Call onClose when tutorial is finished or skipped
        }
      }}
    />
  );
}